/**
 *  项目的配置文件
 */
export const apiUrl = 'http://www.heronlink.hk.cn' //生产环境
// export const apiUrl = 'http://localhost:8230' //生产环境
// export const apiUrl = 'http://heypc.slodon.cn/';//接口请求地址
// export const apiUrl = 'http://159.75.248.230:9003';//接口请求地址
// export const apiUrl = 'http://192.168.242.33:8230' // 张福林
// export const apiUrl = 'http://localhost:8230' // 测试环境
export const curLang = 'en' //当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名
export const chatUrl = 'ws://www.heronlink.hk.cn' //客服地址s
// export const chatUrl = 'ws://localhost:8112';//客服地址

export const title = 'Heronlink' //浏览器顶部title
// ** copyright *** slodon *** version-v2.8 *** date-2021-05-27 ***主版本v2.8
